import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";

import AppLayout from "../components/layout/AppLayout";
import MainLayout from "../components/layout/MainLayout";
import PrivateRoute from "./PrivateRoute";


/* 📌 Páginas privadas */
const Inicio = lazy(() => import("../pages/MapaPage"));
const Dashboard = lazy(() => import("../pages/DashboardPage"));
const Usuarios = lazy(() => import("../pages/UsuariosPage"));
const Destinos = lazy(() => import("../pages/DestinosPage"));
const Configuracion = lazy(() => import("../pages/ConfiguracionPage"));
const Rutas = lazy(() => import("../pages/RutasPage"));
const Recorridos = lazy(() => import("../pages/RecorridosPage"));
const Planificacion = lazy(() => import("../pages/PlanificacionPage"));
const Proximamente = lazy(() => import("../pages/ProximamentePage"));
const MiLicenciaPage = lazy(() => import("../pages/MiLicenciaPage"));

/* 📌 Páginas públicas */
const Login = lazy(() => import("../pages/LoginPage"));
const NoAutorizado = lazy(() => import("../pages/NoAutorizadoPage"));
const ResetPassword = lazy(() => import("../pages/ResetPasswordPage"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>Cargando...</div>}>
        <AppLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />
      },
      /* 🔐 RUTAS PROTEGIDAS */
      {
        element: <PrivateRoute />, // 👈 AQUÍ vive la validación
        children: [
          {
            element: <MainLayout />,
            children: [
              { path: "inicio", element: <Inicio /> },
              { path: "dashboard", element: <Dashboard /> },
              { path: "usuarios", element: <Usuarios /> },
              { path: "destinos", element: <Destinos /> },
              { path: "configuracion", element: <Configuracion /> },
              { path: "rutas", element: <Rutas /> },
              { path: "recorridos", element: <Recorridos /> },
              { path: "planificaciones", element: <Planificacion /> },
              { path: "milicencia", element: <MiLicenciaPage /> },
              { path: "proximamente", element: <Proximamente /> },

            ],
          },
        ],
      },
    ],
  },

  /* 🚫 SIN PERMISOS */
  {
    path: "/no-autorizado",
    element: (
      <Suspense fallback={<div>Cargando...</div>}>
        <NoAutorizado />
      </Suspense>
    ),
  },
]);
